import PropTypes from 'prop-types';
import ImageGallery from 'react-image-gallery';
import 'react-image-gallery/styles/css/image-gallery.css';
import YouTubePreview from '@/pages/sales-flow/components/configuration/config-components/youtube-preview.component';
import Loader from '../loader/loader-component';
import { Container } from './image-carousel-style';

/**
 * ImageCarousel component to display a gallery of images.
 *
 * @param {object} props - The component props.
 * @param {Array} props.images - The array of image objects.
 * @param {boolean} props.loading - is loading or not
 * @returns {JSX.Element} The rendered ImageCarousel component.
 */
const ImageCarousel = ({ images = [], loading, ...props }) => {
  const galleryImages = images.map((image) => {
    if ('embedUrl' in image && image.embedUrl) {
      return {
        original: image.image,
        thumbnail: image.image,
        embedUrl: image.embedUrl,
        renderItem: () => <YouTubePreview url={image.embedUrl} />,
        renderThumbInner: () => (
          <YouTubePreview url={image.embedUrl} thumbnail />
        ),
      };
    }

    return {
      original: image.image,
      thumbnail: image.image,
    };
  });

  return (
    <Container>
      {loading ? (
        <Loader loading className="loading" />
      ) : (
        <ImageGallery
          items={galleryImages}
          showThumbnails
          showFullscreenButton
          showPlayButton={false}
          key={galleryImages?.length}
          lazyLoad
          {...props}
        />
      )}
    </Container>
  );
};

ImageCarousel.propTypes = {
  images: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.string.isRequired,
      alt: PropTypes.string,
    }),
  ).isRequired,
  loading: PropTypes.bool.isRequired,
};

export default ImageCarousel;
